export default __webpack_public_path__ + "static/13hard-51560ae0bd6cb213ca105cfddde2cfeb.png";